import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Layout } from "./layout/Layout";
import { Home } from "./pages/Home";
import { Login } from "./pages/Login";
import { AdminRoute } from "./routes/AdminRoute";
import { useAppDispatch } from "./redux/hooks";
import { useEffect } from "react";
import { refreshToken } from "./redux/slices/adminSlice";
import { Admin } from "./pages/Admin";
import { Category } from "./pages/Category";
import { Brand } from "./pages/Brand";
import { Product } from "./pages/Product";
import { Banner } from "./pages/Banner";
import { Order } from "./pages/Order";
import { Article } from "./pages/Article";
import { Page } from "./pages/Page";
import { Review } from "./pages/Review";
import { Cache } from "./pages/Cache";
import { NotFound } from "./pages/NotFound";

function App() {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(refreshToken());
  }, [dispatch]);
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<AdminRoute />}>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/category" element={<Category />} />
              <Route path="/brand" element={<Brand />} />
              <Route path="/product" element={<Product />} />
              <Route path="/banner" element={<Banner />} />
              <Route path="/order" element={<Order />} />
              <Route path="/article" element={<Article />} />
              <Route path="/page" element={<Page />} />
              <Route path="/review" element={<Review />} />
              <Route path="/cache" element={<Cache />} />
            </Route>
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
